import script from "./FormReceipt.vue?vue&type=script&setup=true&lang=js"
export * from "./FormReceipt.vue?vue&type=script&setup=true&lang=js"

import "./FormReceipt.vue?vue&type=style&index=0&id=ca877912&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca877912"]])

export default __exports__